import { createContext, useReducer } from "react";
import AbmInitialState from "./initialState/abm";
import abm from "./reducers/abm";

export const AdminContext = createContext();

const AdminProvider = ({ children }) => {
  const [abmState, abmDispatch] = useReducer(abm, AbmInitialState);

  return (
    <AdminContext.Provider
      value={{
        abmState,
        abmDispatch,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export default AdminProvider;
